var styles = {"setupFee":"ep-pricing-module-setup-fee-c2V0d"};

export { styles as default };
